import { render, staticRenderFns } from "./DispatchChannelToggles.vue?vue&type=template&id=74c26dae&scoped=true"
import script from "./DispatchChannelToggles.vue?vue&type=script&lang=js"
export * from "./DispatchChannelToggles.vue?vue&type=script&lang=js"
import style0 from "./DispatchChannelToggles.vue?vue&type=style&index=0&id=74c26dae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c26dae",
  null
  
)

export default component.exports